import {DataTable} from "../../components";
import {Layout} from "../../layout";

export const List = () => {
    return (
        <Layout>
            <DataTable/>
        </Layout>
    );
};
